export default __webpack_public_path__ + "static/media/Sustainable-America-Alternate-Logo.b6da76ba.svg";